import { Component, DestroyRef, inject, input } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

import { Store } from '@ngrx/store'

import { tap } from 'rxjs'

import { FlxIconModule, FlxModalService } from '@flowx/angular-ui-toolkit'
import { ConfirmationModalComponent } from '@flowx/designer/shared/components/confirmation-modal/confirmation-modal.component'
import { showModalAboveAiPanel } from '@flowx/designer/shared/utils/modal.utils'

import { ConversationActions } from '../../../../conversation/conversation.actions'
import { ConversationSelectors } from '../../../../conversation/conversation.selectors'

@Component({
  selector: 'flx-ai-chat-agent-marker',
  templateUrl: './ai-chat-agent-marker.component.html',
  imports: [FlxIconModule],
})
export class AiChatAgentMarkerComponent {
  #store = inject(Store)
  #destroyRef = inject(DestroyRef)
  modalService = inject(FlxModalService)

  hasOutcome = this.#store.selectSignal(ConversationSelectors.mainOutcome)
  isLoading = this.#store.selectSignal(ConversationSelectors.loading)

  label = input<string>('')

  clearAgentMark(): void {
    if (this.isLoading()) {
      const modal = showModalAboveAiPanel(
        this.modalService,
        ConfirmationModalComponent,
        {
          appendTo: 'body',
          closeOnBackdropClick: false,
        },
        {
          message: `You are about to lose the progress on this task. Do you confirm?`,
          btnOkText: `Confirm`,
        }
      )

      modal.data$
        .pipe(
          tap((data: { confirm }) => {
            if (data.confirm) {
              this.#store.dispatch(ConversationActions.discardThreadClick({}))
            }
          }),
          takeUntilDestroyed(this.#destroyRef)
        )
        .subscribe()

      return
    }

    this.#store.dispatch(ConversationActions.discardThreadClick({}))
  }
}
